export default {
  "diagnosticCodes_title": "Diagnostic Code for",
  "diagnosticCodes_code": "CODE",
  "diagnosticCodes_definition": "DEFINITION",
  "diagnosticCodes_when": "WHEN",
  "diagnosticCodes_active": "ACTIVE",
  "diagnosticCodes_history": "HISTORY",
  "diagnosticCodes_clear": "CLEAR",
  "diagnosticCodes_done": "DONE",
  "diagnosticCodes_noData": "No data found",
}